var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-sidebar"},[_c('plugin-search'),_vm._v(" "),_c('category-selector'),_vm._v(" "),_c('nav-items',{staticClass:"tw-hidden lg:tw-block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }